import { useId } from 'react';
import { Slider as Base } from '@base-ui/react/slider';
import { cn } from './cn';

/** A labelled slider (Base UI: arrow keys, Page Up/Down, Home/End), with its value shown by `format`. */
export function Slider({
  label,
  value,
  min,
  max,
  step = 1,
  onValueChange,
  format = String,
  disabled,
  className,
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onValueChange: (value: number) => void;
  format?: (value: number) => string;
  disabled?: boolean;
  className?: string;
}) {
  const id = useId();
  return (
    <div className={cn('flex flex-col gap-1.5 font-sans text-sm text-fg', className)}>
      <div className="flex items-center justify-between gap-2">
        <span id={id}>{label}</span>
        <span className="text-xs text-fg-muted tabular-nums">{format(value)}</span>
      </div>
      <Base.Root value={value} min={min} max={max} step={step} disabled={disabled} onValueChange={(v) => onValueChange(v as number)}>
        <Base.Control className="flex h-5 items-center pointer-coarse:h-11 data-[disabled]:opacity-50">
          <Base.Track className="h-1 w-full rounded-full bg-border">
            <Base.Indicator className="rounded-full bg-accent" />
            <Base.Thumb
              getAriaLabel={() => label}
              aria-labelledby={id}
              className="block h-4 w-4 rounded-full border border-border-strong bg-surface shadow-sm has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-focus"
            />
          </Base.Track>
        </Base.Control>
      </Base.Root>
    </div>
  );
}
